<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="600">
    <v-card v-if="row != null">
      <OperationDialogTitle v-bind="row" @close="dismiss" />
      <v-card-text class="pa-3">
        <v-form
          ref="theForm"
          v-model="isValid"
          class="d-flex flex-wrap items-start"
        >
          <OAutocomplete
            :readonly="readonly"
            class="w-full pa-3"
            v-model="row.vehicleId"
            label="Veículo"
            placeholder="Selecione..."
            :items="vehicles"
            clearable
          />

          <ODateTimeInput2
            :readonly="readonly"
            class="w-full pa-3"
            label="Data/hora"
            v-model="row.timestamp"
            :clearable="false"
          />

          <OTextarea
            :readonly="readonly"
            class="w-full pa-3"
            label="Comentários"
            v-model="row.comments"
            :rows="2"
            filled
            autofocus
            :rules="[isSet]"
          />

          <RowDates class="ma-3" :value="row" />
        </v-form>
      </v-card-text>
      <ODialogButtons
        class="pa-4"
        txtApply="Salvar"
        @apply="apply"
        @cancel="dismiss"
      />
    </v-card>
  </ODialog>
</template>

<script>
import TheUser from 'oderon-vue/auth/TheUser'
import { ClientHistory } from '../../../models'
import RowDates from './RowDates.vue'
import OperationDialogTitle from './OperationDialogTitle.vue'
import {
  postOrPatch,
  fetchVehiclesOfInterest,
  findActiveInstall,
  canEdit
} from './operation-utils'
import { isSet } from 'oderon-vue/utils.js'

export default {
  components: { RowDates, OperationDialogTitle },
  data() {
    let start = this.reset()
    return {
      ...start,
      isSet,
      TheUser
    }
  },
  computed: {
    readonly() {
      return this.row && this.row.id && !canEdit(this.TheUser)
    }
  },
  methods: {
    reset() {
      return {
        isValid: false,
        row: null
      }
    },

    async open({ clientId, historyId }) {
      Object.assign(this, this.reset())

      if (this.$refs.theForm) this.$refs.theForm.resetValidation()

      this.$refs.dialog.$loading(() => this.fetchAll(clientId, historyId))

      return this.$refs.dialog.$open()
    },

    async fetchAll(clientId, historyId) {
      this.vehicles = await fetchVehiclesOfInterest(clientId)
      if (historyId == null) {
        let activeInstall = await findActiveInstall(clientId)
        this.row = {
          timestamp: new Date(),
          clientId: clientId,
          type: 'troubleshooting',
          subType: 'identify',
          vehicleId: activeInstall && activeInstall.vehicleId
        }
      } else {
        this.row = await ClientHistory.findById(historyId)
      }
    },

    apply() {
      if (this.$refs.theForm.validate()) {
        this.$refs.dialog.$loading(async () => {
          await postOrPatch('/clients/:cid/troubleshooting', this.row)
          this.$snack('Registro salvo com sucesso')
          this.$refs.dialog.$apply('RELOAD')
        })
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style></style>
